module.exports = __webpack_public_path__ + "img/client-list.f4560537.svg";